<template>
    <span class="AnnouncementPreview">
        <!--
        <span v-if="infoType == 'txt' || infoType=='html' || infoType=='ext'">{{ info.tiedoteTextList["1"] }} </span>
        <span v-if="infoType == 'img'"><AnnouncementImage :imageid="info.tunnus" :showResolution="showResolution" /> </span>
        -->
        <span v-if="infoType == 1 || infoType == 5">{{ info.tiedoteTextList["1"] }} </span>
        <span v-if="infoType == 4"><AnnouncementImage :imageid="info.tunnus" :showResolution="showResolution" /> </span>
    </span>
</template>

<script>
import AnnouncementImage from '@/components/Announcements/AnnouncementImage'

export default {
    name:"AnnouncementPreview",
    /*props: ['info' , 'scale'], */
     props: {
      info: { default: null },
      scale: { default: null },
      showResolution: { type: Boolean, default: true },
    },
    components: { AnnouncementImage },
    computed: {
         infoType() {
            var type = "?"
            if( this.info ) 
                type = this.info.tyyppi;
            return type;
        },
        old_infoType() {
            var type = "?"
            if( this.info ) {
                if( this.info.externalId )
                    return "ext"
                if( this.info.tyyppi) {
                    if( this.info.tyyppi == 1 )
                        return "txt"
                    if( this.info.tyyppi == 4 )
                        return "img"
                    if( this.info.tyyppi == 6 )
                        return "html"
                }
            }
            return type
        },
        iscale() {
            return this.scale ? this.scale : "1"
        }
    }
}
</script>